<template>
  <div class="navbarmenu-notifications">
    <b-dropdown>
      <a v-if="isPublic" slot="trigger" class="text-black hover:text-grey">
        <b-icon icon="bell" pack="fas" size="is-small" class="float-left"></b-icon>
        <span class="px-1 py-0 text-xs text-white rounded-full bg-red">{{ total }}</span>
      </a>
      <a v-else slot="trigger" class="text-black hover:text-grey">
        <b-icon icon="bell" pack="fas" size="is-small" class="float-left"></b-icon>
      </a>

      <div class="w-full pb-2 pr-2 text-right" v-if="total > 0">
        <a
          v-on:click="getNotifications(false, 1)"
          v-if="onlyUnread"
          class="button is-light is-small"
        >
          <b-icon pack="fa" class="float-left" size="is-small" icon="eye"></b-icon>
          <span>{{ $t('notifications_show_all') }}</span>
        </a>

        <a v-on:click="showUnread(1)" v-if="!onlyUnread" class="button is-light is-small">
          <b-icon pack="fa" class="float-left" size="is-small" icon="envelope"></b-icon>
          <span>{{ $t('notifications_show_unread') }}</span>
        </a>

        <a v-on:click="readAllNotifications" class="ml-1 button is-light is-small">
          <b-icon pack="fa" class="float-left" size="is-small" icon="check-circle"></b-icon>
          <span>{{ $t('notifications_mark_as_read') }}</span>
        </a>
      </div>
      <div class="w-full pb-2 pr-2 text-sm font-bold text-center" v-else>
        <span>{{ $t('notifications_not_pending_to_read') }}</span>
      </div>

      <b-dropdown-item
        v-for="notification in notifications"
        :key="notification.id"
        style="padding-right:1rem!important; border-top:1px solid #e9e9e9; width: 500px; white-space: initial"
        v-bind:class="{ 'bg-grey-lighter': !notification.read_at }"
      >
        <div
          :id="notification.id"
          v-on:click="goToNotification(notification.id)"
          class="media"
        >
          <div class="mt-1 media-left relative">
            <div style="width: 60px; height: 60px; position: relative;">
              <b-icon
                pack="fa"
                class="rounded-full text-white"
                style="background-color: rgb(85, 119, 187) !important; width: 60px; height: 60px;"
                :icon="notification.data.notification_icon"
              ></b-icon>
            </div>

              <img class="rounded-full absolute bottom-0 -right-1.5"
              width="25" height="25"
              :src="notification.data.avatar ? notification.data.avatar : '/img/icon-user-default.png'">
          </div>

            <!-- style="overflow:visible!important; min-width:500px;" -->
          <div
            class="media-content"
          >
            <h3 class="font-semibold">{{ notification.data.notification_title }}</h3>
            <div v-if="notification.data.flow_activity_name">{{ notification.data.flow_activity_name }}</div>
            <div v-if="notification.data.flow_parent_activity_name">{{ notification.data.flow_parent_activity_name }}</div>
            <!-- <b-icon
              pack="fa"
              class="float-left mt-1 mr-1"
              size="is-small"
              :icon="notification.data.notification_icon"
            ></b-icon> -->
            <div class="">
              <p class="text-sm text-gray-600 line-clamp-3">{{ notification.data.notification_message }}</p>
            </div>

            <div v-if="notification.data.notification_title != projectName(notification)">
              <span class="text-xs italic"> ({{ projectName(notification) }})</span>
            </div>

            <div>
              <l-timeago
                :since="notification.created_at"
                :locale="locale"
                class="my-1 text-xs font-semibold text-blue-light"
              />
            </div>
          </div>
        </div>
      </b-dropdown-item>

      <div class="w-full pb-2 pr-2 text-center">
        <a v-on:click="fetchData" class="button is-light is-small" v-if="this.page < this.last">
          <b-icon pack="fa" class="float-left" size="is-small" icon="eye"></b-icon>
          <span>Ver más</span>
        </a>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import Vue from "vue";
import Pusher from "pusher-js";
import axios from "axios";
import store from "~/store";
import Echo from "laravel-echo";
import EventBus from "~/plugins/bus";
import { mapGetters } from "vuex";
import VueLodash from "vue-lodash";
import MugenScroll from "vue-mugen-scroll";
import FirebasePlugin from "~/plugins/firebase";

const options = { name: "lodash" };
Vue.use(VueLodash, options);

export default {
  components: {
    MugenScroll
  },

  data() {
    return {
      isPublic: true,
      loading: false,
      isLoadingTable: true,
      page: 1,
      last: 1,
      total: 0,
      onlyUnread: false,
      fetchingFirstPage: false,
      notifications: [],
      params: []
    };
  },
  computed: {
    ...mapGetters({
      locale: "lang/locale",
      company: 'app/company',
      companies: 'app/companies',
      project: 'app/project',
      importEntities: 'app/importEntities'
    })
  },
  methods: {

    projectName(notification) {
      return notification.data.pictogram_project_name || notification.data.activity_project_name || notification.data.flow_project_name || ''
    },

    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },

    fetchData() {
      if (this.page <= this.last) {
        this.isLoadingTable = true;
        this.getNotifications(false, this.page);
        this.isLoadingTable = false;
      }
    },

    async showUnread(page) {
      // Marcamos
      var self = this;
      this.onlyUnread = true;
      this.notifications = [];

      // Obtenemos las notificaciones sin leer del usuario
      const { data } = await axios.get(
        "/api/v2/user/notifications/unread/web?page=" + page
      );
      //console.log(data);
      // Paginas totales
      this.last = data.last;

      if (data && data.success) {
        // Hacemos comprobaciones de la paginacion
        if (this.page > 1 && this.page <= this.last) {
          data.data.forEach(function(element) {
            self.notifications.push(element);
          });

          this.isLoadingTable = false;
          this.page = this.page + 1;
        } else {
          self.notifications = data.data;
          this.isLoadingTable = false;
          this.page = this.page + 1;
        }

        // Variables para mostrar total de notificaciones independiente de la paginacion
        this.total = data.unread;
        this.total > 0 ? (this.isPublic = true) : (this.isPublic = false);
      }
    },

    async readAllNotifications() {
      // Obtenemos las notificaciones sin leer del usuario
      const { data } = await axios.get("/api/v2/user/notifications/readall");

      if (data && data.success) {
        // Obtenemos las notificaciones de nuevo.
        this.getNotifications(false, this.page);

        // Notificamos con buefy
        this.$notify.info("all_read");

        // Refrescamos los componentes dependiente de notificaciones
        EventBus.$emit("refreshNotifications", true);
      }
    },

    async connectToFirebase() {

      if (! FirebasePlugin.isSupported())
        return 0;

      FirebasePlugin.initialize();

      // Gestiona recepcion de mensajes en primer plano (pestaña activa)
      // (gestion de mensajes en 2º plano en public/firebase-messaging-sw.js)
      FirebasePlugin.onMessage(function(payload) {

        // notificaciones silenciosas no traen la key 'notification'
        if (!payload.notification) {
          console.log("no payload.notification detected")
          return 0
        }

        new Notification(
          payload.notification.title || 'sin titulo',
          {
            body: payload.notification.body || 'epc-tracker',
            icon: payload.notification.icon || 'https://epcv2-global-assets.s3-eu-west-1.amazonaws.com/public/logotriangulo.png'
          }
        );
      });

    },

    async connectToPusher() {
      // Obtenemos al usuario
      const user = store.getters["auth/user"];
      var self = this;

      // Si existe el usuario, abrimos el canal
      if (user && window.Echo == undefined) {

        // LARAVEL ECHO & PUSHER
        let connection = window.Echo = new Echo({
          broadcaster: "pusher",
          key: process.env.MIX_PUSHER_APP_KEY,
          cluster: process.env.MIX_PUSHER_APP_CLUSTER,
          encrypted: true,
          authEndpoint: "/user/authEcho",
          disableStats: true,
          auth: {
            headers: {
              Authorization: "Bearer " + store.getters["auth/token"]
            }
          }
        });

        var channel = window.Echo.private("App.User." + user.id);

        // Incluimos el nombre del cliente por si utilizamos el mismo canal de pusher para varios entornos
        channel.on("notify", function(e) {

          // mis propias notifs, siempre silent sea lo q sea
          if( e.executor_user_id && e.executor_user_id == user.id ){
            e.sound === 'false'
          }

          let refreshNotifications = e.sound === 'false' ? false : true;
          switch(e.type) {
            case "MessageChatPusher":
              EventBus.$emit("refreshChatNotifications", true);
              refreshNotifications = false;
              break;
            case "refreshProgress":
              EventBus.$emit("refreshProgress", e.progress);
              refreshNotifications = false;
              break;
            case "refreshStatus":
              EventBus.$emit("refreshStatus", e.status);
              refreshNotifications = false;
              break;
            case 'IssueDeleted':
              refreshNotifications = false;
              break;
            case 'IssueAssigned':
              EventBus.$emit("refreshIssuesNotifications", true);
              break;
            case 'IssueTaskAssigned':
              refreshNotifications = true;
              EventBus.$emit("issueTaskRefresh", e);
              break;
            case 'IssueClosed':
              refreshNotifications = true;
              EventBus.$emit("refreshIssuesNotifications", e);
              break;
            case 'IssueValidationFlowAssigned':
              refreshNotifications = true;
              EventBus.$emit("issueValidationFlowRefresh", e);
              break;
            case 'IssueExpired':
              refreshNotifications = true;
              break;
            case 'ActivityDeleted':
              refreshNotifications = false;
            break;
            case 'ActivityAssigned':
              EventBus.$emit("refreshActivitiesNotifications", true);
              break;
            case 'SubactivityDeleted':
              refreshNotifications = false;
              break;
            case 'SubactivityAssigned':
              EventBus.$emit("refreshSubactivitiesNotifications", true);
              break;
            case 'SubactivityDocumentDeleted':
            case 'ActivityDocumentDeleted':
              EventBus.$emit("refreshActivityDocumentsNotifications", false);
              refreshNotifications = false;
              break;
            case 'SubactivityDocumentUploaded':
            case 'ActivityDocumentUploaded':
              EventBus.$emit("refreshActivityDocumentsNotifications", false);
              break;
            case 'IssueDocumentDeleted':
              refreshNotifications = false;
              break;
            case 'IssueDocumentUploaded':
              EventBus.$emit("refreshIssueDocumentsNotifications", true);
              break;
            case 'ActivityDocumentUpdated':
            case 'SubactivityDocumentUpdated':
              EventBus.$emit("refreshActivityDocumentsNotifications", true);
              EventBus.$emit("refreshAssignmentChangedNotifications", e);
              break;

            case 'FolderUpdated':
              refreshNotifications = false;
              EventBus.$emit("refreshFolderDocuments", e);
              EventBus.$emit("refreshActivityDocumentsNotifications", e);
              break;


            // FLUJO DE VALIDACION

            case 'ValidationFlowAssigned':
              refreshNotifications = true;
              EventBus.$emit("refreshValidations", e);
              break;

            case 'CertificationFlowGenerated':
              refreshNotifications = true;
              EventBus.$emit("refreshCertifications", e);
              break;

            case 'ParticipantsValidationFlowNotification':
              refreshNotifications = false;
              EventBus.$emit("refreshValidationTasks", e);
              EventBus.$emit("refreshValidations", e);
              break;

            case 'RejectedValidationFlowTaskNotification':
            case 'NextValidationFlowTaskNotification':
            case 'ValidationFlowPendingAnswer':
              // refreshNotifications = true;. No forzar, hacer lo que diga e.sound arriba, para no notificar al usuario que hace la accion
              break;

            case 'ValidationDeleted':
              refreshNotifications = false;
              EventBus.$emit("refreshValidations", e);
              break;

            case 'ValidationCompleted':
              EventBus.$emit("refreshValidations", e);
              break;

            case 'ValidationRejected':
              EventBus.$emit("refreshValidations", e);
              break;

            // ----------------------------------------------


            case 'IssueDocumentUpdated':
              refreshNotifications = false;
              EventBus.$emit("refreshIssueDocumentsNotifications", true);
              break;
            case 'ValidationDocumentUpdated':
              refreshNotifications = false;
              EventBus.$emit("refreshValidationDocumentsNotifications", true);
              break;
            case 'ProjectDocumentUpdated':
            case 'ProjectDocumentDeleted':
              refreshNotifications = false;
              EventBus.$emit("refreshProjectDocumentsNotifications", e);
              break;
            case "readNotifications":
              refreshNotifications = false;
              break;
            case 'SubActivityCompleted':
              refreshNotifications = false;
              break;
            case 'ActivityCompleted':
              refreshNotifications = false;
              break;
            case 'ActivityProgressChange':
            case 'ActivityProgress':
            case 'SubactivityProgress':
              EventBus.$emit("refreshActivitiesNotifications", true);
              refreshNotifications = false;
              break;
            case 'ActivityGroupProgressRecalculated':
              // Progreso de grupos ya persistido tras el job asíncrono.
              EventBus.$emit("refreshActivitiesNotifications", true);
              refreshNotifications = false;
              break;
            case 'AssignmentChanged':
            case 'MeasurementProgressRejected':
            case 'MeasurementProgressPartialValidation':
              EventBus.$emit("refreshAssignmentChangedNotifications", e);
              refreshNotifications = false;
              break;
            case 'AssignmentDeleted':
              EventBus.$emit("refreshAssignmentDeletedNotifications", e);
              refreshNotifications = false;
              break;
            case 'AssignmentCreated':
              EventBus.$emit("refreshAssignmentCreatedNotifications", e);
              refreshNotifications = false;
              break;
            case 'KanbanRefresh':
              EventBus.$emit("kanbanRefresh", e);
              refreshNotifications = false;
              break;
            case 'ActivityCommented':
            case 'SubactivityCommented':
              e.entity = 'activity';
              EventBus.$emit("refreshComments", e);
              break;
            case 'ActivityCommentUpdated':
            case 'SubactivityCommentUpdated':
            case 'ActivityCommentDeleted':
              refreshNotifications = false;
              e.entity = 'activity';
              EventBus.$emit("refreshComments", e);
              break;
            case 'IssueCommented':
              e.entity = 'issue';
              EventBus.$emit("refreshComments", e);
              break;
            case 'IssueCommentUpdated':
            case 'IssueCommentDeleted':
              refreshNotifications = false;
              e.entity = 'issue';
              EventBus.$emit("refreshComments", e);
              break;
            case 'ValidationCommented':
              e.entity = 'validation';
              EventBus.$emit("refreshComments", e);
              break;
            case 'ValidationCommentUpdated':
            case 'ValidationCommentDeleted':
              refreshNotifications = false;
              e.entity = 'validation';
              EventBus.$emit("refreshComments", e);
              break;
            case 'zipReady':
              // Pusher notifs are private per user. Conditional just in case, due to sensitive information
              if( e.executor_user_id && e.executor_user_id == user.id ){
                window.open(e.url);
                self.$notify.success('downloaded_folder');
              }

              break;
            case 'importEntities':
              if( e.executor_user_id && e.executor_user_id == user.id ){
                let importEntities = self.importEntities || {}
                if (!importEntities[e.entity_type]) {
                  importEntities[e.entity_type] = {}
                }
                if (e.status == 'success') {
                  // En P6 el historial ya se creó en el Job, solo notificamos y limpiamos
                  let isP6 = e.params && e.params.source === 'primavera_p6'
                  if (isP6) {
                    self.$notify.success('success_import');
                    importEntities[e.entity_type][`${e.project_id}`] = {}
                    self.$store.dispatch('app/setImportEntities', {importEntities})
                  } else {
                    // subimos excel secuencialmente para evitar race condition
                    let chunkSize = 500
                    // let data = importEntities[e.entity_type][`${e.project_id}`].data
                    let data = importEntities[e.entity_type][`${e.project_id}`].data || []

                    const uploadChunks = async () => {
                      for (let i = 0; i < data.length; i += chunkSize) {
                        let chunk = data.slice(i, i + chunkSize);
                        let isLast = (i + chunkSize) >= data.length
                        let params = {
                          ...e.params,
                          reset: i === 0,
                          is_last: isLast,
                          data: chunk
                        }
                        try {
                          await axios.post(`/api/v2/import/${e.entity_type}/optimized/upload`, params)
                        } catch (err) {
                          // error subiendo el excel del historial; no bloqueamos al usuario
                        }
                      }

                      // tal vez subir estas 3 lineas antes de uploadChunks() porque ahi la importacion ya ha terminado y los datos estan en BD. Tan solo se quedaria subiendo el fichero al historial
                      // notificamos y reseteamos storage
                      self.$notify.success('success_import');
                      importEntities[e.entity_type][`${e.project_id}`] = {}
                      self.$store.dispatch('app/setImportEntities', {importEntities})
                    }
                    uploadChunks()
                  }

                } else {
                  let currentData = importEntities[e.entity_type][`${e.project_id}`]
                  // Usamos total_rows del backend si la data local está vacía (datasets grandes)
                  let totalRows = (currentData.data && currentData.data.length > 0) ? currentData.data.length : (e.total_rows || 0)
                  let newImportEntities = {
                    type: e.import_type,
                    lastImportedIndex: e.last_imported_index,
                    status: currentData.status,
                    data: currentData.data,
                    chunkProgress: currentData.chunkProgress,
                    progress: currentData.progress,
                    lastNotification: Date.now()
                  }
                  if (e.status == 'error') {
                    self.$notify.error('error_import');
                    newImportEntities.status = 'error'
                    newImportEntities.errors = e.data
                  } else  {
                    // Calculamos progreso real basado en last_imported_index
                    if (totalRows > 0 && e.last_imported_index != null) {
                      newImportEntities.progress = Math.min(99, Math.round(((e.last_imported_index + 1) / totalRows) * 100))
                    } else {
                      newImportEntities.progress += currentData.chunkProgress
                    }
                    // No mostramos alerta en cada paso, solo avanza la barra
                  }
                  importEntities[e.entity_type][`${e.project_id}`] = newImportEntities
                  self.$store.dispatch('app/setImportEntities', {importEntities})
                }
              }

              break;

            case 'BulkAction':
              // Bulk Action notifs are private per user
              if( e.executor_user_id && e.executor_user_id == user.id ){
                let dataBulk = JSON.parse(e.data)

                // Para acciones sobre mediciones (move/remove) usamos un toast traducido
                // con más duración que el genérico de backend, y disparamos un EventBus
                // para que la página de bulk-actions auto-refresque su lista sin que el
                // usuario tenga que recargar manualmente.
                if (dataBulk.action_name === 'move_assignments' || dataBulk.action_name === 'remove_assignments') {
                  const i18nKey = dataBulk.action_name === 'move_assignments'
                    ? 'bulk_move_assignments_done'
                    : 'bulk_remove_assignments_done'
                  self.$toast.open({
                    message: self.$t(i18nKey),
                    type: 'is-success',
                    position: 'is-top-right',
                    duration: 6000,
                  })
                  EventBus.$emit('bulkAssignmentsCompleted', {
                    action: dataBulk.action_name,
                    projectId: parseInt(dataBulk.project_id),
                  })
                } else {
                  self.$notify.success(dataBulk.message);
                }
              }
              break;

            case 'Processlog':
              // Bulk Action notifs are private per user
              if ( e.executor_user_id && e.executor_user_id == user.id ) {
                EventBus.$emit("processQueueLog", e);
              }
              break;

            case 'PictogramAdvance':
              // al propio usuario ejecutor de la accion no se notifica, al resto si
              if( e.executor_user_id && e.executor_user_id == user.id ) {
                refreshNotifications = false;
                self.$notify.success('pictogram_progress_updated');
              }
              break;

            case 'PictogramScreenshotUpdated':
              EventBus.$emit('refreshPictogramScreenshot', e);
              refreshNotifications = false;
            break;
          }

          // Refrescamos notificaciones
          self.notifications = [];
          self.getNotifications(refreshNotifications, 1);

          if (refreshNotifications) {
            EventBus.$emit("refreshNotifications", e);
            EventBus.$emit("refreshBellCounter", e); // actualiza la campana de la instancia viva via bus (+1 y resync)
          } else {
            // eventos silenciosos (p.ej. AssignmentChanged): algunos acompañan a notificaciones
            // que solo se escriben en BD, resincronizamos el numero de la campana sin sumar
            EventBus.$emit("refreshBellSync", e);
          }

        });
      }
    },
    // Llega una notificación por Pusher (posiblemente a otra instancia): subimos el
    // contador al instante y luego getNotifications lo ajusta con el valor del servidor
    onBellCounterPush() {
      this.total = (this.total || 0) + 1;
      this.isPublic = true;
      this.getNotifications(false, 1);
    },

    // Evento silencioso: solo resincroniza el numero con el servidor
    onBellSync() {
      this.getNotifications(false, 1);
    },

    async getNotifications(launchToast, page) {
      // candado: dos cargas simultaneas de la pagina 1 (pusher + bus) se pisaban
      // this.page entre si y la segunda APILABA la lista en vez de reemplazarla (duplicados)
      if (page === 1) {
        if (this.fetchingFirstPage) return;
        this.fetchingFirstPage = true;
      }

      try {

      // Referenciamos
      var self = this;

      // Marcamos
      this.onlyUnread = false;
      this.page = page;

      // Obtenemos las notificaciones sin leer del usuario
      const { data } = await axios.get(
        "/api/v2/user/notifications/web?page=" + page
      );

      // Paginas totales
      this.last = data.last;

      //console.log(data);
      if (data && data.success) {
        // Hacemos comprobaciones de la paginacion
        if (this.page > 1 && this.page <= this.last) {
          data.data.forEach(function(element) {
            self.notifications.push(element);
          });

          this.isLoadingTable = false;
          this.page = this.page + 1;
        } else {
          self.notifications = data.data;
          this.isLoadingTable = false;
          this.page = this.page + 1;
        }

        // Variables para mostrar total de notificaciones independiente de la paginacion
        this.total = data.unread;
        this.total > 0 ? (this.isPublic = true) : (this.isPublic = false);
      }

      if (launchToast) {
        // TODO. quitado el sound por problemas de repiques. Activar cuando sea resuelto
        // self.playSound(self.asset('public/sounds/notification.mp3'));
        this.$notify.info("new_notification");
      }

      } finally {
        if (page === 1) {
          this.fetchingFirstPage = false;
        }
      }
    },

    async goToNotification(notification) {

      // Preparamos el array para enviarlos
      var notifications = { id: notification };

      // Marcamos como leída la notificación
      const { data } = await axios.post("/api/v2/notification/read", {
        notifications: notifications
      });

      if (data && data.success) {

        // Parseamos la respuesta
        var obj = JSON.parse(data.data.data);

        let notificationProjectId = obj.activity_project_id || obj.flow_project_id || obj.project_id

        let dataProjectNotification = await this.getDataProject(notificationProjectId); // retorna un objeto que contiene project y company
        let currentProjectId = this.project ? this.project.id : null; // identificador del projecto actual o null si no se selecciono aún

        // Verificamos si la notificación pertenece a un proyecto diferente al actual
        if( dataProjectNotification.project && dataProjectNotification.project.id != currentProjectId ) {
          let notificationCompany = dataProjectNotification.company
          // verificamos si la company es diferente a la actual si lo es seteamos en el storage la company antes de setear el proyecto
          if( notificationCompany.id != this.company.id ) {

            await this.$store.dispatch("app/setCompany", { company: notificationCompany });
            // await this.$store.dispatch("app/setGroup", { group: null });
          }

          // por defecto seteamos siempre el project si es diferente
          let notificationProject = dataProjectNotification.project
          await this.$store.dispatch("app/setProject", { project: notificationProject });
          let tags = dataProjectNotification.project.tags
          await this.$store.dispatch("app/setTags", { tags });
        }

        if (obj.type == "ProjectAssigned") {
          // // const { data } = await axios.get("/api/v2/user/projects", {
          // //   'params' : { companyId: this.company.id }
          // // });

          // // let project = data.projects.find(proj => proj.id == obj.activity_project_id)
          // await this.$store.dispatch("app/setProject", { project });
          // let tags = project.tags
          // await this.$store.dispatch("app/setTags", { tags });

          // Redirigimos a la ruta
          this.$router.push(
            "/project"
          );
        } else if (
          obj.type == "SubactivityAssigned" ||
          obj.type == "SubactivityCommented" ||
          obj.type == "SubactivityDocumentUploaded" ||
          obj.type == "SubactivityDocumentMention" ||
          obj.type == "SubactivityCommentMention" ||
          obj.type == "SubactivityCompleted" ||
          obj.type == "SubactivityPictogramAdvance"
        ) {
          // Redirigimos a la ruta
          this.$router.push({
            name: "subactivity.home",
            params: {
              activity_id: obj.activity_parent_id,
              subactivity_id: obj.activity_id
            }
          });
        } else if (
          obj.type == "IssueCommented" ||
          obj.type == "IssueCommentMention" ||
          obj.type == "IssueDocumentUploaded" ||
          obj.type == "IssueDocumentMention" ||
          obj.type == "IssueAssigned"
        ) {
          // Redirigimos a la ruta adecuada según si es incidencia de subactividad o no
          if (obj.activity_subactivity) {
            this.$router.push({ name: "issue.home-sub", params: { subactivity_id: obj.activity_id, activity_id: obj.activity_parent_id, issue_id: obj.issue_id } });
          } else {
            this.$router.push({ name: "issue.home", params: { activity_id: obj.activity_id, issue_id: obj.issue_id } });
          }

        } else if (
          obj.type == "ActivityAssigned" ||
          obj.type == "ActivityCommented" ||
          obj.type == "ActivityDocumentUploaded" ||
          obj.type == "ActivityDocumentMention" ||
          obj.type == "ActivityCommentMention" ||
          obj.type == "ActivityCompleted" ||
          obj.type == "MeasurementProgressPending" ||
          obj.type == "ActivityPictogramAdvance"
        ) {
          // Redirigimos a la ruta
          this.$router.push({
            name: "activity.home",
            params: { activity_id: obj.activity_id }
          });
        } else if (
          obj.type == "ValidationFlowPending" ||
          obj.type == "ValidationDocumentMention" ||
          obj.type == "NextValidationFlowTaskNotification" ||
          obj.type == "RejectedValidationFlowTaskNotification" ||
          obj.type == "ValidationFlowAssigned" ||
          obj.type == "CertificationFlowGenerated" ||
          obj.type == "ValidationCommented" ||
          obj.type == "ValidationCommentMention"
        ) {
          // Redirigimos a la ruta
          this.$router.push({
            name: "validation.home",
            params: { validation_id: obj.flow_id }
          });
        } else if (
          obj.type == "MeasurementProgressRejected" ||
          obj.type == "MeasurementProgressPartialValidation"
        ) {
          // Redirigimos a la ruta
          this.$router.push({
            name: "project.measurements"
          });
        }

        // de momento dejamos comentado esta linea por que se esta enviando o redirigiendo a la ruta de la actividad o subactividad
        // que contiene el pictograma
        // else if (
        //   obj.type == "PictogramAdvance"
        // ) {
        //   // Redirigimos a la ruta
        //   this.$router.push({
        //     name: "webviewer.pictograms",
        //     params: { pictogram_id: obj.pictogram_id, wl: obj.layer, activity: obj.activity_parent_id, subactivity: obj.activity_id }
        //   });
        // }



        // Obtenemos las notificaciones de nuevo.
        this.getNotifications(false, this.page);
      }
    },

    async getDataProject(id) {
      let companies = this.companies

      let project = null;
      let company = null;

      for (let index = 0; index < companies.length; index++) {
        company = companies[index]
        if( company.projects ) {
          project = company.projects.find(p => p.id == id);
          if( project )
            break
        }
      }

      return { project: project, company: company };
    }
  },

  created() {
    this.getNotifications(false, this.page), this.connectToPusher();
    this.connectToFirebase();

    // El canal Pusher queda enganchado a la PRIMERA instancia de este componente de la
    // pestaña (guard window.Echo). Tras un remontaje del navbar, el evento lo recibe esa
    // instancia vieja y la campana visible no se enteraba: el bus global es el puente.
    // Evento dedicado (no 'refreshNotifications'): otros componentes hacen $off global
    // de ese nombre al desmontarse y matarían este listener.
    EventBus.$on("refreshBellCounter", this.onBellCounterPush);
    EventBus.$on("refreshBellSync", this.onBellSync);
  },

  beforeDestroy() {
    // $off con callback: elimina solo el listener propio
    EventBus.$off("refreshBellCounter", this.onBellCounterPush);
    EventBus.$off("refreshBellSync", this.onBellSync);
  }
};
</script>

<style scoped>
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.line-clamp-none {
  overflow: visible;
  display: block;
  -webkit-box-orient: horizontal;
  -webkit-line-clamp: none;
}
</style>

